const ErrorConstants = {
  // From GraphQL /listing endpoint
  RENT_ZESTIMATE_NOT_FOUND: 'RENT_ZESTIMATE_NOT_FOUND',
  GET_COMPS_PRICE_EMPTY: 'GET_COMPS_PRICE_EMPTY',
  PROPERTY_DETAILS_NOT_FOUND: 'PROPERTY_DETAILS_NOT_FOUND',
};

export default ErrorConstants;
